import React from "react";
import NavBar from "../NavBar";
import HomeScreenContentTop from "./HomeScreenContentTop";
import HomeScreenPopularPDFTools from "./HomeScreenPopularPDFTools";
import Footer from "../Footer";
import HomeScreenHowToUse from "./HomeScreenHowToUse";
import WhyChooseShivaPDF from "./WhyChooseShivaPDF";
import HomeScreenTrustedByMillions from "./HomeScreenTrustedByMillions";
import HomeScreenMultiPlatform from "./HomeScreenMultiPlatform";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import HomeScreenPopularImageTools from "./HomeScreenPopularImageTools";
import HomeScreenViewAllAppsView from "./HomeScreenViewAllAppsView";

function HomeScreenMain() {
  return (
    <div>
      {/*Add title and metadata */}
      <title>Shiva PDF | Free Browser Based PDF Editing Tool Loads Online Then Works Offline</title>
      <meta name="robots" content="index, follow"></meta>
      <link rel="canonical" href={BASE_URL} />
      <meta
        name="description"
        content="Edit PDF files online easily. Use PDF editing tools to modify text, pages, merge, split, compress, and manage PDFs securely and fast."
      ></meta>
      <meta
        name="keywords"
        content="pdf tools, pdf editing tools, pdf editor online, edit pdf, pdf management tool, merge pdf, pdf merger, combine pdf files, split pdf, pdf splitter, compress pdf, pdf compressor, reduce pdf size, pdf under 200kb, pdf converter, pdf to word, word to pdf, pdf to excel, excel to pdf, pdf to ppt, ppt to pdf, pdf to image, image to pdf, html to pdf, rearrange pdf, reorder pdf pages, delete pdf pages, extract pdf pages, rotate pdf, crop pdf, resize pdf, flatten pdf, lock pdf, unlock pdf, protect pdf, remove pdf password, watermark pdf, add watermark to pdf, number pdf pages, add page numbers to pdf, pdf annotator, annotate pdf, pdf ocr, scanned pdf to text, translate pdf, pdf translator, pdf summarizer, grayscale pdf, pdf metadata editor, edit pdf properties, pdf n up, multiple pages per sheet pdf, pdf viewer, view pdf online, secure pdf, encrypt pdf, online pdf editor, free pdf tools, all in one pdf tool"
      ></meta>

      {/* Nav Bar */}
      <NavBar />
      {/* Content top */}
      <HomeScreenContentTop />
      {/* Favourite PDF Tools */}
      <HomeScreenPopularPDFTools />
      {/* Favourite Image Tools */}
      <HomeScreenPopularImageTools />
      {/* View All Apps */}
      <HomeScreenViewAllAppsView />
      {/* How to use */}
      <HomeScreenHowToUse
        steps={{
          step1: "Select",
          step2: "Offline",
          step3: "Convert",
          step4: "Download",
        }}
      />
      {/* Trusted */}
      <HomeScreenTrustedByMillions />
      {/* Multi Platform Supported */}
      <HomeScreenMultiPlatform />
      {/* Why choose shiva pdf */}
      <WhyChooseShivaPDF />
      {/* Download on Appsroe */}
      <MiscDownloadOnAppStore
        id={`https://apps.apple.com/app-bundle/id${1863317370}`}
      />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default HomeScreenMain;
